// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProfileAvatar_wrapper__3H07r","img":"ProfileAvatar_img__2F-m6","icon":"ProfileAvatar_icon__3ON6b"};